import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'
import { PieChartData, URGENCY_COLORS, URGENCY_LABELS } from '@/lib/api/dashboard/dashboard-api'

interface TriageUrgencyChartProps {
    data: PieChartData[]
}

export default function TriageUrgencyChart({ data }: TriageUrgencyChartProps) {
    const chartData = data.map(d => ({
        ...d,
        color: d.color || URGENCY_COLORS[d.name] || '#94a3b8',
    }))

    const total = chartData.reduce((acc, d) => acc + d.value, 0)

    const urgencyOrder = ['RED', 'ORANGE', 'YELLOW', 'GREEN', 'BLUE']
    const orderedLabels = Object.entries(URGENCY_LABELS)
        .sort((a, b) => urgencyOrder.indexOf(a[0]) - urgencyOrder.indexOf(b[0]))

    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 p-5">
            <h3 className="text-lg font-semibold text-base-content mb-4">
                Triagens por Urgencia
            </h3>

            {total === 0 ? (
                <div className="flex items-center justify-center h-64 text-base-content/50">
                    Sem dados de triagem
                </div>
            ) : (
                <>
                    <div className="w-full" style={{ height: '200px', minHeight: '200px' }}>
                        <ResponsiveContainer width="100%" height={200}>
                            <PieChart>
                                <Pie
                                    data={chartData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={50}
                                    outerRadius={80}
                                    paddingAngle={2}
                                    dataKey="value"
                                    nameKey="name"
                                >
                                    {chartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                <Tooltip
                                    formatter={(value) => [value ?? 0, 'Triagens']}
                                    contentStyle={{
                                        backgroundColor: 'oklch(var(--b1))',
                                        border: '1px solid oklch(var(--b3))',
                                        borderRadius: '8px',
                                    }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>

                    <div className="grid grid-cols-5 gap-1 mt-4">
                        {orderedLabels.map(([key, label]) => {
                            const item = chartData.find(
                                d => d.name === label || d.name === key
                            )
                            const color = URGENCY_COLORS[key]
                            return (
                                <div
                                    key={key}
                                    className="flex flex-col items-center p-2 rounded-lg"
                                    style={{ backgroundColor: `${color}15` }}
                                >
                                    <div
                                        className="w-3 h-3 rounded-full mb-1"
                                        style={{ backgroundColor: color }}
                                    />
                                    <span className="text-[10px] text-base-content/70 text-center">
                                        {label.split(' ')[0]}
                                    </span>
                                    <span
                                        className="text-sm font-bold"
                                        style={{ color }}
                                    >
                                        {item?.value || 0}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </>
            )}
        </div>
    )
}
